import { createSlice } from '@reduxjs/toolkit';

import { updateAuthenticationToken } from '@/features/authentication-update-token/store/thunks/update-authentication-token';
import { GameDataLoadingState } from '@/features/game/types';

export type AuthenticationState = {
  loadingState: GameDataLoadingState;
  updateAuthenticationError?: Record<string, unknown>;
};

const initialState: AuthenticationState = {
  loadingState: GameDataLoadingState.NotStarted,
};

const authenticationUpdateTokenSlice = createSlice({
  name: 'authenticationUpdateToken',
  reducers: {},
  initialState,
  extraReducers: (builder) => {
    builder.addCase(updateAuthenticationToken.pending, (state) => {
      state.loadingState = GameDataLoadingState.Loading;
    });
    builder.addCase(updateAuthenticationToken.fulfilled, (state) => {
      state.loadingState = GameDataLoadingState.Completed;
    });
    builder.addCase(updateAuthenticationToken.rejected, (state, action) => {
      state.loadingState = GameDataLoadingState.Failed;
      state.updateAuthenticationError = action.payload as Record<
        string,
        unknown
      >;
    });
  },
});

export const authenticationUpdateTokenReducer =
  authenticationUpdateTokenSlice.reducer;
